const {h, render, Component} = require('preact');

class SeeAllGroupons extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let ordersCount = this.props.length
    let grouponsCount = this.props.groupons
    if (grouponsCount > 20 || ordersCount >= 4) {
      let seeAllGroupons = <div class="landing-step-actions" data-bhw="web2018_see_all_groupons">
        <a href="/customer_support/web/orders" class="btn-invert" id="see-all-groupons">
          {I18n.t('js.modules.web_2018.see_all_groupons')}</a>
      </div>
      return seeAllGroupons;
    }
    return null;
  }
}

module.exports = SeeAllGroupons
